/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Eyebrow_StartedInputs */

const en_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started`)
};

const es_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza`)
};

const de_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legen Sie los`)
};

const zh_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始使用`)
};

const ar_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابدأ الآن`)
};

const fr_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer`)
};

const vi_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu`)
};

const sw_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anza`)
};

const th_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่มต้นเลย`)
};

const bs_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Započnite`)
};

const ja_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`始める`)
};

const ko_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시작하기`)
};

const pt_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece agora`)
};

const it_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniziare`)
};

const sv_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom igång`)
};

const nl_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starten`)
};

const da_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

const nb_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom i gang`)
};

const fi_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita`)
};

const pl_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij`)
};

const ru_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начинай.`)
};

const tr_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlayın`)
};

const hi_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरू करना`)
};

const id_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai`)
};

const ms_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulakan`)
};

const cs_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Začít`)
};

const el_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ξεκινήστε`)
};

const he_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`להתחיל`)
};

const af_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begin hier`)
};

const hu_home_eyebrow_started = /** @type {(inputs: Home_Eyebrow_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kezdés`)
};

/**
* | output |
* | --- |
* | "Get Started" |
*
* @param {Home_Eyebrow_StartedInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_eyebrow_started = /** @type {((inputs?: Home_Eyebrow_StartedInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Eyebrow_StartedInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_eyebrow_started(inputs)
	if (locale === "de") return de_home_eyebrow_started(inputs)
	if (locale === "zh") return zh_home_eyebrow_started(inputs)
	if (locale === "ar") return ar_home_eyebrow_started(inputs)
	if (locale === "fr") return fr_home_eyebrow_started(inputs)
	if (locale === "vi") return vi_home_eyebrow_started(inputs)
	if (locale === "sw") return sw_home_eyebrow_started(inputs)
	if (locale === "th") return th_home_eyebrow_started(inputs)
	if (locale === "bs") return bs_home_eyebrow_started(inputs)
	if (locale === "ja") return ja_home_eyebrow_started(inputs)
	if (locale === "ko") return ko_home_eyebrow_started(inputs)
	if (locale === "pt") return pt_home_eyebrow_started(inputs)
	if (locale === "it") return it_home_eyebrow_started(inputs)
	if (locale === "sv") return sv_home_eyebrow_started(inputs)
	if (locale === "nl") return nl_home_eyebrow_started(inputs)
	if (locale === "da") return da_home_eyebrow_started(inputs)
	if (locale === "nb") return nb_home_eyebrow_started(inputs)
	if (locale === "fi") return fi_home_eyebrow_started(inputs)
	if (locale === "pl") return pl_home_eyebrow_started(inputs)
	if (locale === "ru") return ru_home_eyebrow_started(inputs)
	if (locale === "tr") return tr_home_eyebrow_started(inputs)
	if (locale === "hi") return hi_home_eyebrow_started(inputs)
	if (locale === "id") return id_home_eyebrow_started(inputs)
	if (locale === "ms") return ms_home_eyebrow_started(inputs)
	if (locale === "cs") return cs_home_eyebrow_started(inputs)
	if (locale === "el") return el_home_eyebrow_started(inputs)
	if (locale === "he") return he_home_eyebrow_started(inputs)
	if (locale === "af") return af_home_eyebrow_started(inputs)
	if (locale === "hu") return hu_home_eyebrow_started(inputs)
	return en_home_eyebrow_started(inputs)
});